import {
  HIDE_DETAIL_CONTRIBUTION_DIALOG,
  SHOW_DETAIL_CONTRIBUTION_DIALOG,
} from 'src/store/actionTypes';

import { setDialogConfig } from 'src/core/dialog/DialogPersistence';

import { updateObject } from 'src/store/reducers/commons';

const getDefaultState = () => ({
  isOpen: false,
});

const _toggleDialog = (state, action, value) => {
  setDialogConfig({ isOpen: value, actionName: value ? 'hideDetailContributionDialog' : '' });
  return updateObject(state, { isOpen: value });
};

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case HIDE_DETAIL_CONTRIBUTION_DIALOG:
      return _toggleDialog(state, action, false);
    case SHOW_DETAIL_CONTRIBUTION_DIALOG:
      return _toggleDialog(state, action, true);

    default:
      return state;
  }
};
